import React, { Component } from 'react'
import './Customers.css'
import { uniqBy } from 'lodash';
import { titleCase } from '../../../../Utility'

class Customers extends Component {
    constructor(props) {
        super(props)

        this.state = {
            companies: []
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.topCompanies.company_details && nextProps.topCompanies.company_details.length > 0) {
            var companies_temp = nextProps.topCompanies.company_details.map((item) => {
                item.company_name = item.company_name ? item.company_name.toUpperCase() : ''
                return item
            })
            companies_temp = uniqBy(companies_temp, 'company_name')
            return {
                companies: companies_temp
            }
        }
        else {
            return {
                companies: []
            }
        }
    }
    render() {
        let p = this.state.companies.map((company, i) => {

            return (
                <div key={i}>
                    {
                        company.company_name ? (
                            <div className="company_name" key={i}> <span>{titleCase(company.company_name)}</span> </div>
                        ) : null
                    }
                </div>
            )
        }
        )

        return (
            <div className="container s-cont">
                <h3 className="data_header">Customers</h3>

                {
                    (this.state.companies.length > 0) ? (
                        p
                    ) : (
                        /* companies.map(company =>
                            <div className="col-6 company">
                           
                                                             <img src={(company.logo!=null&&company.logo!=undefined&&company.logo!='')?(company.logo):("https://image.flaticon.com/icons/svg/236/236832.svg")} ></img>
                                                                    <span className="company_name"> {company.company_name} </span>
                          </div>
                        ) */
                            <div className="undefined">
                                <p>
                                    Details not available
                                </p>
                            </div>
                    )
                }

            </div>
        )
    }
}

export default Customers
